import { c as _c } from "react/compiler-runtime";
import request from '@onefootprint/request';
import type { BusinessRequest, BusinessResponse } from '@onefootprint/types';
import { KYB_BO_SESSION_AUTHORIZATION_HEADER } from '@onefootprint/types';
import { useQuery } from '@tanstack/react-query';
const getBusinessRequest = async ({
  obConfigAuth
}: BusinessRequest) => {
  const {
    data
  } = await request<BusinessResponse>({
    method: 'GET',
    url: '/hosted/business',
    headers: obConfigAuth
  });
  return data;
};
const useBusiness = payload => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== payload) {
    t0 = ["get-business", payload];
    t1 = () => getBusinessRequest(payload);
    $[0] = payload;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = !!payload?.obConfigAuth && KYB_BO_SESSION_AUTHORIZATION_HEADER in payload.obConfigAuth;
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const query = useQuery(t3);
  return query;
};
export default useBusiness;